import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import bbox from '@turf/bbox';
import { centroid } from '@turf/turf';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Map, { Layer, NavigationControl, Popup, Source, GeolocateControl } from 'react-map-gl';
import wellknown, { parse } from 'wellknown';
import satelliteIcon from '../../../assets/images/satellite.png';
import streetsIcon from '../../../assets/images/streets.png';
import PopupContent from './Popup';

import axios from 'axios';

import DrawControl from './draw-control/DrawControl';
import styles from './Map.module.css';
import ResultProperties from './Result-properties';
import { useLocation } from 'react-router-dom';

mapboxgl.accessToken =
  'pk.eyJ1IjoibXRheXlhYm1pciIsImEiOiJjbDZuaWQ5Z3QwMTNyM2tsbGs2emtlc21uIn0.cwMj_2X3NoUdcbWnLGiG4g';

/* eslint-disable import/no-webpack-loader-syntax */
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

const mapStyles = {
  streets: 'mapbox://styles/mapbox/streets-v9',
  satellite: 'mapbox://styles/mapbox/satellite-v9'
};

export default function MapComponent(props) {

  const location = useLocation();

  const { ownerProperties } = props;

  /** Map ref */
  const map = useRef();
  // filters parcelids
  const [parcelnumb, setParcelnumb] = useState(props.filterParcelIds || []);

  const [showWMS, setShowWMS] = useState(props.filterParcelIds == null);

  // console.log("showWMS",showWMS)

  const [isDrawToolsActive, setIsDrawToolsActive] = useState(false);

  const [staticFeature, setStaticFeaute] = useState(null);

  const [isMobileScreen, setIsMobileScreen] = useState(false);

  const [zipBoundary, setZipBoundary] = useState(null);
  const [pntGeoJson, setPntGeoJson] = useState({
    type: 'FeatureCollection',
    features: []
  });

  const [hoveredFeature, setHoveredFeature] = useState({
    type: 'FeatureCollection',
    features: []
  });
  //  console.log('hoveredFeature', hoveredFeature);
  const [viewport, setViewport] = useState({
    // 34.044902, -84.342369
    longitude: -84.342369,
    latitude: 34.044902,
    zoom: 13
  });

  const filterPnts = `parcelnumberraw IN (${parcelnumb
    .map((num) => `'${num}'`)
    .join(',')})`;

  // console.log("fietttttt", filter);
  useEffect(() => {
    // console.log('Filtered Parcelnumb IDs:', parcelnumb);
  }, [parcelnumb]);

  /** Basemaps */
  const [basemap, setBasemap] = useState(
    props.defaultBasemap || mapStyles.satellite
  );
  const changeBasemap = () => {
    if (basemap === mapStyles.satellite) {
      setBasemap(mapStyles.streets);
    } else {
      setBasemap(mapStyles.satellite);
    }
  };

  /** Focused data:  Layer style*/

  const focusedParcelStyle = props.parcelStyle || {
    id: 'focused',
    type: 'fill',
    paint: {
      'fill-color':
        basemap === mapStyles.satellite ? 'rgba(0,0,0,0)' : '#C7BC9F',
      'fill-outline-color': '#67773F'
    }
  };

  /** Static Feature style style */
  const staticFeatureStyle = {
    id: 'static-feature',
    type: 'fill',
    paint: {
      'fill-color': 'rgba(4, 174, 196, 0.1)', // 50% transparent blue
      'fill-outline-color': 'rgb(4, 174, 196)'
    }
  };


  /** Popup state */
  const [showPopup, setShowPopup] = useState(false);
  const [popupLocation, setPopupLocation] = useState({
    latitude: 0,
    longitude: 0
  });

  const closePopup = () => setShowPopup(true);
  const [drawStarted, setDrawStarted] = useState(false);

  const [focusedParcel, setFocusedParcel] = useState({
    type: 'FeatureCollection',
    features: []
  });

  const [detailsParcelGeom, setDetailsParcelGeom] = useState(
    props.detailsParcelGeom || undefined
  );


  function isValidBoundingBox(bbox) {
    try {
      if (!Array.isArray(bbox) || bbox.length !== 4) {
        console.error('Invalid bbox structure:', bbox);
        return false;
      }
    
      const [minLng, minLat, maxLng, maxLat] = bbox;
    
      const isValidLngLat = (lng, lat) =>
        typeof lng === 'number' && typeof lat === 'number' &&
        lng >= -180 && lng <= 180 &&
        lat >= -90 && lat <= 90;
    
      // Validate each corner of the bounding box
      return (
        isValidLngLat(minLng, minLat) &&
        isValidLngLat(maxLng, maxLat) &&
        minLng <= maxLng && // Ensure proper bbox bounds
        minLat <= maxLat
      );
    }
    catch (error) {
      console.error('Error validating bounding box:', error);
      return false;
    }
    
  }

  useEffect(() => {
    if (pntGeoJson.features) {
      setHoveredFeature(
        pntGeoJson.features.find(
          (f) =>
            f.properties.parcelno === props.hoverParcelId
        )
      );
    }
  }, [props.hoverParcelId]);

  useEffect(() => {
    if (!showWMS) {
      // showWFSData();
      setTimeout(() => {
        let _pntGeoJson = null;
        if (props.page === 'details') {
          // Single Property Details
          const property = JSON.parse(localStorage.getItem('propertyData'))
          if (property && property.lat && property.long) {
            _pntGeoJson = {
              type: 'FeatureCollection',
              features: [{
                type: 'Feature',
                geometry: {
                  type: 'Point',
                  coordinates: [+property.long, +property.lat]
                },
                properties: {
                  parcelno: property.parcel_id
                }
              }]
            }
          }
        } else if (props.page === 'owner') {
          if (ownerProperties) {
            _pntGeoJson = {
              type: 'FeatureCollection',
              features: ownerProperties.filter(pr => pr.latitude != null && pr.longitude != null).map(property => ({
                type: 'Feature',
                geometry: {
                  type: 'Point',
                  coordinates: [+property.longitude, +property.latitude]
                },
                properties: {
                  parcelno: property.parcel_id
                }
              }))
            }

          }
        }
        else {
          // All Filtered Properties
          const listingProperties = JSON.parse(localStorage.getItem('listingData')).parcel_ids;
          const _zipBoundary = JSON.parse(localStorage.getItem('listingData')).zipGeometry;
          if (_zipBoundary && _zipBoundary.length > 0) {
            setZipBoundary(parse(_zipBoundary));
            // console.log('parsed zip' ,parse(_zipBoundary));
          } else {
            setZipBoundary(null);
          }

          if (listingProperties) {
            _pntGeoJson = {
              type: 'FeatureCollection',
              features: listingProperties.filter(prop => prop.long != null && prop.lat != null).map(property => ({
                type: 'Feature',
                geometry: {
                  type: 'Point',
                  coordinates: [+property.long, +property.lat]
                },
                properties: {
                  parcelno: property.parcelno
                }
              }))
            }
          }
        }
        if (_pntGeoJson) {


          setPntGeoJson(_pntGeoJson);

          if (props.page === 'owner' || (props.page === 'results')) {

            if (_pntGeoJson.features.length > 0) {
              const [minLng, minLat, maxLng, maxLat] = bbox(_pntGeoJson);
              const { innerWidth, innerHeight } = window;
              const padding = Math.min(innerWidth, innerHeight)
              map.current.fitBounds(
                [
                  [minLng, minLat],
                  [maxLng, maxLat]
                ],
                { padding: 20, duration: 1000 }
              );
            }
          }
        }
      }, 500)
    }
  }, []);

  useEffect(() => {
    if (!!focusedParcel.features.length && !isDrawToolsActive) {
      setShowPopup(true);
    }
  }, [popupLocation]);

  useEffect(() => {
    if (focusedParcel.features.length > 0) {
      const [minLng, minLat, maxLng, maxLat] = bbox(focusedParcel.features[0]);
      if (isValidBoundingBox([minLng, minLat, maxLng, maxLat])) {
        map.current.fitBounds(
          [
            [minLng, minLat],
            [maxLng, maxLat]
          ],
          { padding: 100, duration: 1000 }
        );
      }

    }
  }, [focusedParcel])

  

  useEffect(() => {

    if ((props.page === 'details' && pntGeoJson.features.length > 0) || (props.page === 'results' && pntGeoJson.features.length === 1)) {

      const lat = pntGeoJson.features[0].geometry.coordinates[1];
      const lng = pntGeoJson.features[0].geometry.coordinates[0];

      const size = 0.0001;

      var parameters = {
        service: 'WMS',
        version: '1.1.1',
        request: 'GetFeatureInfo',
        layers: 'rhinorecon:parcels',
        query_layers: 'rhinorecon:parcels',
        feature_count: 50,
        info_format: 'application/json',
        format_options: 'callback:handleJson',
        SrsName: 'EPSG:4326',
        width: 101,
        height: 101,
        x: 50,
        y: 50,
        bbox:
          lng -
          size +
          ',' +
          (lat - size) +
          ',' +
          (lng + size) +
          ',' +
          (lat + size)
      };
      axios
        .get(`https://geoserver.rhinorecon.com/geoserver/rhinorecon/wms`, {
          params: parameters
        })
        .then((res) => {
          setFocusedParcel(res.data);
        });
    }
  }, [props.page, pntGeoJson]);

  const handleClick = useCallback((event) => {

    event.preventDefault();
    if (!isDrawToolsActive) {
      const { lng, lat } = event.lngLat;
      const size = 0.0001;

      var parameters = {
        service: 'WMS',
        version: '1.1.1',
        request: 'GetFeatureInfo',
        layers: 'rhinorecon:parcels',
        query_layers: 'rhinorecon:parcels',
        feature_count: 50,
        info_format: 'application/json',
        format_options: 'callback:handleJson',
        SrsName: 'EPSG:4326',
        width: 101,
        height: 101,
        x: 50,
        y: 50,
        bbox:
          lng -
          size +
          ',' +
          (lat - size) +
          ',' +
          (lng + size) +
          ',' +
          (lat + size)
      };
      // const mapPadding = props.mapZoomPadding || 0.005;
      axios
        .get(`https://geoserver.rhinorecon.com/geoserver/rhinorecon/wms`, {
          params: parameters
        })
        .then((res) => {
          setFocusedParcel(res.data);
          const [minLng, minLat, maxLng, maxLat] = bbox(res.data);
          const { innerWidth, innerHeight } = window;
          const padding = Math.min(innerWidth, innerHeight)

          map.current.fitBounds(
            [
              [minLng, minLat],
              [maxLng, maxLat]
            ],
            {
              padding: 20,
              duration: 1000
            }
          );
          const _parcelCentroid = centroid(res.data);
          // console.log('_parcelCentroid', _parcelCentroid)
          setPopupLocation({ latitude: _parcelCentroid.geometry.coordinates[1], longitude: _parcelCentroid.geometry.coordinates[0] });
        });
    }
  });

  useEffect(() => {
    // map.fitBounds to the drawn features
    if (props.drawnFeatures && map.current) {
      const drawnFeatures = wellknown.parse(props.drawnFeatures);
      const [minLng, minLat, maxLng, maxLat] = bbox(drawnFeatures);
      const { innerWidth, innerHeight } = window;
      const padding = Math.min(innerWidth, innerHeight)

      map.current.fitBounds(
        [
          [minLng, minLat],
          [maxLng, maxLat]
        ],
        {
          padding: 50,
          duration: 1000
        }
      );
      props.handleSearchClick && props.handleSearchClick();

    }
  }, [props.drawnFeatures, map.current]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const geom = urlParams.get('geometry');

    if (geom) {
      setStaticFeaute(geom);
    }
  }
    , []);


  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth <= 800); // Change the value according to your mobile screen breakpoint
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  return (
    <div
      style={{
        width: '100%',
        height: showWMS
          ? 'calc(100vh - 21rem)'
          : props.page === 'details'
            ? 'calc(100vh - 25rem)'
            : 'calc(100vh - 28rem)'
      }}
    >
      <Map
        ref={map}
        initialViewState={viewport}
        style={{
          width: '100%',
          height: props.mapHeight ? props.mapHeight : '100%',
        }}
        mapStyle={basemap}
        onClick={!props.isStatic && handleClick}
        interactiveLayerIds={['parcels-wms-lyr']}
      >
        <div
          style={{
            position: 'absolute',
            top: 20,
            left: 10,
            zIndex: 1000,
            padding: '5px',
          }}
        >
          <img
            src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 fill-rule=%27evenodd%27 viewBox=%270 0 88 23%27%3E%3Cdefs%3E%3Cpath id=%27logo%27 d=%27M11.5 2.25c5.105 0 9.25 4.145 9.25 9.25s-4.145 9.25-9.25 9.25-9.25-4.145-9.25-9.25 4.145-9.25 9.25-9.25zM6.997 15.983c-.051-.338-.828-5.802 2.233-8.873a4.395 4.395 0 013.13-1.28c1.27 0 2.49.51 3.39 1.42.91.9 1.42 2.12 1.42 3.39 0 1.18-.449 2.301-1.28 3.13C12.72 16.93 7 16 7 16l-.003-.017zM15.3 10.5l-2 .8-.8 2-.8-2-2-.8 2-.8.8-2 .8 2 2 .8z%27/%3E%3Cpath id=%27text%27 d=%27M50.63 8c.13 0 .23.1.23.23V9c.7-.76 1.7-1.18 2.73-1.18 2.17 0 3.95 1.85 3.95 4.17s-1.77 4.19-3.94 4.19c-1.04 0-2.03-.43-2.74-1.18v3.77c0 .13-.1.23-.23.23h-1.4c-.13 0-.23-.1-.23-.23V8.23c0-.12.1-.23.23-.23h1.4zm-3.86.01c.01 0 .01 0 .01-.01.13 0 .22.1.22.22v7.55c0 .12-.1.23-.23.23h-1.4c-.13 0-.23-.1-.23-.23V15c-.7.76-1.69 1.19-2.73 1.19-2.17 0-3.94-1.87-3.94-4.19 0-2.32 1.77-4.19 3.94-4.19 1.03 0 2.02.43 2.73 1.18v-.75c0-.12.1-.23.23-.23h1.4zm26.375-.19a4.24 4.24 0 00-4.16 3.29c-.13.59-.13 1.19 0 1.77a4.233 4.233 0 004.17 3.3c2.35 0 4.26-1.87 4.26-4.19 0-2.32-1.9-4.17-4.27-4.17zM60.63 5c.13 0 .23.1.23.23v3.76c.7-.76 1.7-1.18 2.73-1.18 1.88 0 3.45 1.4 3.84 3.28.13.59.13 1.2 0 1.8-.39 1.88-1.96 3.29-3.84 3.29-1.03 0-2.02-.43-2.73-1.18v.77c0 .12-.1.23-.23.23h-1.4c-.13 0-.23-.1-.23-.23V5.23c0-.12.1-.23.23-.23h1.4zm-34 11h-1.4c-.13 0-.23-.11-.23-.23V8.22c.01-.13.1-.22.23-.22h1.4c.13 0 .22.11.23.22v.68c.5-.68 1.3-1.09 2.16-1.1h.03c1.09 0 2.09.6 2.6 1.55.45-.95 1.4-1.55 2.44-1.56 1.62 0 2.93 1.25 2.9 2.78l.03 5.2c0 .13-.1.23-.23.23h-1.41c-.13 0-.23-.11-.23-.23v-4.59c0-.98-.74-1.71-1.62-1.71-.8 0-1.46.7-1.59 1.62l.01 4.68c0 .13-.11.23-.23.23h-1.41c-.13 0-.23-.11-.23-.23v-4.59c0-.98-.74-1.71-1.62-1.71-.85 0-1.54.79-1.6 1.8v4.5c0 .13-.1.23-.23.23zm53.615 0h-1.61c-.04 0-.08-.01-.12-.03-.09-.06-.13-.19-.06-.28l2.43-3.71-2.39-3.65a.213.213 0 01-.03-.12c0-.12.09-.21.21-.21h1.61c.13 0 .24.06.3.17l1.41 2.37 1.4-2.37a.34.34 0 01.3-.17h1.6c.04 0 .08.01.12.03.09.06.13.19.06.28l-2.37 3.65 2.43 3.7c0 .05.01.09.01.13 0 .12-.09.21-.21.21h-1.61c-.13 0-.24-.06-.3-.17l-1.44-2.42-1.44 2.42a.34.34 0 01-.3.17zm-7.12-1.49c-1.33 0-2.42-1.12-2.42-2.51 0-1.39 1.08-2.52 2.42-2.52 1.33 0 2.42 1.12 2.42 2.51 0 1.39-1.08 2.51-2.42 2.52zm-19.865 0c-1.32 0-2.39-1.11-2.42-2.48v-.07c.02-1.38 1.09-2.49 2.4-2.49 1.32 0 2.41 1.12 2.41 2.51 0 1.39-1.07 2.52-2.39 2.53zm-8.11-2.48c-.01 1.37-1.09 2.47-2.41 2.47s-2.42-1.12-2.42-2.51c0-1.39 1.08-2.52 2.4-2.52 1.33 0 2.39 1.11 2.41 2.48l.02.08zm18.12 2.47c-1.32 0-2.39-1.11-2.41-2.48v-.06c.02-1.38 1.09-2.48 2.41-2.48s2.42 1.12 2.42 2.51c0 1.39-1.09 2.51-2.42 2.51z%27/%3E%3C/defs%3E%3Cmask id=%27clip%27%3E%3Crect x=%270%27 y=%270%27 width=%27100%25%27 height=%27100%25%27 fill=%27white%27/%3E%3Cuse xlink:href=%27%23logo%27/%3E%3Cuse xlink:href=%27%23text%27/%3E%3C/mask%3E%3Cg id=%27outline%27 opacity=%270.3%27 stroke=%27%23000%27 stroke-width=%273%27%3E%3Ccircle mask=%27url%28%23clip%29%27 cx=%2711.5%27 cy=%2711.5%27 r=%279.25%27/%3E%3Cuse xlink:href=%27%23text%27 mask=%27url%28%23clip%29%27/%3E%3C/g%3E%3Cg id=%27fill%27 opacity=%270.9%27 fill=%27%23fff%27%3E%3Cuse xlink:href=%27%23logo%27/%3E%3Cuse xlink:href=%27%23text%27/%3E%3C/g%3E%3C/svg%3E"
            alt="Mapbox Logo"
            style={{ height: '20px' }}
          />
        </div>
        <NavigationControl position='bottom-right' />
        <GeolocateControl position='bottom-right'
          positionOptions={{ enableHighAccuracy: true }}
          trackUserLocation={false}
        />
        {!isMobileScreen && map && map.current && props.page !== 'details' && (
          <DrawControl
            map={map.current}
            controls={['polygon', 'circle']}
            drawnFeatures={props.drawnFeatures}
            setDrawnFeatures={props.setDrawnFeatures}
            isDrawToolsActive={isDrawToolsActive}
            setIsDrawToolsActive={setIsDrawToolsActive}
            handleSearch={props.handleSearchClick}
            resetFilters={props.resetFilters}
            setPntGeoJson={setPntGeoJson}
            setStaticFeaute={setStaticFeaute}
            setHoveredFeature={setHoveredFeature}
            setShowWMS={setShowWMS}
            setShowowners={props.setShowowners}
            setListingData={props.setListingData}
            Maptoggle={props.Maptoggle}
            setSearchQueryValues={props.setSearchQueryValues}
            setFilteredProperties={props.setFilteredProperties}
            filteredProperties={props.filteredProperties}
            handleSubmit={props.handleSubmit}
            propertyTypeExists={props.propertyTypeExists}
          />
        )}
        {showPopup && (
          <Popup
            longitude={popupLocation.longitude}
            latitude={popupLocation.latitude}
            anchor='bottom'
            onClose={() => {
              setShowPopup(false);
              setFocusedParcel({ type: 'FeatureCollection', features: [] });
            }}
          >
            <PopupContent
              feature={
                focusedParcel.features.length && focusedParcel.features[0]
              }
            />
          </Popup>
        )}
        {!props.hideParcelsLyr && (
          <Source
            id='parcels-wms'
            type='raster'
            tiles={[
              `https://geoserver.rhinorecon.com/geoserver/rhinorecon/wms?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=256&height=256&layers=rhinorecon:parcels`
            ]}
            tileSize={256}
          >
            <Layer id='parcels-wms-lyr' type='raster' minzoom={10} />
          </Source>
        )}
        {showWMS && (
          <>
            <Source
              id='points-wms'
              type='raster'
              tiles={[
                `https://geoserver.rhinorecon.com/geoserver/rhinorecon/wms?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=256&height=256&layers=rhinorecon:vw_pnt_property_data_new`
              ]}
              tileSize={256}
            >
              <Layer id='points-wms-lyr' type='raster' />
            </Source>
          </>
        )}
        {!showWMS && pntGeoJson && (
          <>
            <Source type='geojson' data={pntGeoJson}>
              <Layer
                id='wfs-layer'
                type='circle'
                paint={{
                  'circle-color': '#67773f',
                  'circle-radius': 7,
                  'circle-stroke-color': '#fff',
                  'circle-stroke-width': 2
                }}
              />
            </Source>

            <Source type='geojson' data={hoveredFeature}>
              {!props.isStatic && (
                <Layer
                  id='wfs-layer2'
                  type='circle'
                  paint={{
                    'circle-color': 'yellow',
                    'circle-radius': 10,
                    'circle-stroke-color': '#67773f',
                    'circle-stroke-width': 2
                  }}
                />
              )}
            </Source>
          </>
        )}
        {
          zipBoundary && (
            <Source type='geojson' data={zipBoundary}>
              <Layer
                id='zip-boundary'
                type='line'
                paint={{
                  'line-color': '#67773f',
                  'line-width': 2
                }}
              />
            </Source>
          )
        }
        {props.page === 'details' && pntGeoJson && (
          <>
            <Source type='geojson' data={pntGeoJson}>
              <Layer
                id='highlted-point'
                type='circle'
                paint={{
                  'circle-color': 'rgba(0,0,0,0)',
                  'circle-radius': 12,
                  'circle-stroke-color': 'yellow',
                  'circle-stroke-width': 2
                }}
              />
            </Source>
          </>
        )}
        {focusedParcel.features.length > 0 && (
          <Source type='geojson' data={focusedParcel}>
            <Layer
              {...focusedParcelStyle}
              beforeId={showWMS ? 'points-wms-lyr' : 'wfs-layer'}
            />
          </Source>
        )}
        {staticFeature && props.page === 'results' && (
          <Source type='geojson' data={parse(staticFeature)}>
            <Layer {...staticFeatureStyle} />
          </Source>
        )}
        {detailsParcelGeom && (
          <Source type='geojson' data={detailsParcelGeom}>
            <Layer {...focusedParcelStyle} />
          </Source>
        )}
      </Map>
      {
        props.page !== 'owner' &&
        <div className={styles.changeBasemap} onClick={changeBasemap}>
          <img
            src={basemap === mapStyles.satellite ? streetsIcon : satelliteIcon}
            alt='basemap'
          ></img>
        </div>
      }

    </div>
  );
}
